import { render, staticRenderFns } from "./ItemsReceivedFiltersRep.vue?vue&type=template&id=cc63944e&"
import script from "./ItemsReceivedFiltersRep.vue?vue&type=script&lang=js&"
export * from "./ItemsReceivedFiltersRep.vue?vue&type=script&lang=js&"
import style0 from "./ItemsReceivedFiltersRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports